import React from 'react';
import styled from 'styled-components';

import { DesktopOnly, MobileOnly } from 'shared/components';

import { useOrderReceiptModal } from './use-order-receipt-modal';
import { OrderReceiptDesktop } from './order-receipt-desktop';
import { OrderReceiptMobile } from './order-receipt-mobile';
import { OrderReceiptMobileV2 } from './order-receipt-mobile-v2';

export const OrderReceiptModal = ({ onClose, ...props }) => {
  const { dispensary, order, loading, useMobileOrderReceiptV2 } = useOrderReceiptModal();

  return (
    <>
      <StyledDesktopOnly>
        <OrderReceiptDesktop dispensary={dispensary} onClose={onClose} order={order} loading={loading} {...props} />
      </StyledDesktopOnly>

      {!useMobileOrderReceiptV2 && (
        <StyledMobileOnly>
          <OrderReceiptMobile dispensary={dispensary} onClose={onClose} order={order} loading={loading} />
        </StyledMobileOnly>
      )}
      {useMobileOrderReceiptV2 && (
        <EmbeddedStyledMobile>
          <OrderReceiptMobileV2 dispensary={dispensary} onClose={onClose} order={order} loading={loading} />
        </EmbeddedStyledMobile>
      )}
    </>
  );
};

const StyledDesktopOnly = styled(DesktopOnly)`
  width: fit-content;
  max-width: 100%;
  margin: 0 auto;
  height: 100%;
  overflow: auto;
  position: relative;
  &::-webkit-scrollbar {
    width: 0;
    border: 0;
    height: 0;
    background: transparent;
  }
`;

const StyledMobileOnly = styled(MobileOnly)`
  height: 100%;
  padding-top: 90px;
`;

const EmbeddedStyledMobile = styled(MobileOnly)`
  overflow: auto;
  height: 100%;
`;
